// routes
import Router from './routes'; 
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
// import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { deviceDetect } from 'react-device-detect';
// ---------------- ------------------------------------------------------
import HTTPManager from './utils/httpRequestManager';
import React from 'react';
import { IdleTimerProvider } from 'react-idle-timer'

import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './app.css';

export default class App extends React.Component{
  httpManager = new HTTPManager();

  constructor(){
    super();
    this.state={

    }
  }

  onPromp(){
    // Fire a Modal Prompt
  }

  onIdle() {
    // Close Modal Prompt
    // Do some idle action like log out your user
    window.localStorage.clear();
    window.location.href="/"
  }

  onActive(event){
    // Close Modal Prompt
    // Do some active action
  }

  onAction(event){
    // Do something when a user triggers a watched event
  }
 

  componentDidMount(){ 
    var accessToken=window.localStorage.getItem('accessToken') || '' 
    if(accessToken === ''){ 
      this.httpManager.postRequest(`common/getToken`, deviceDetect(window.navigator.userAgent)).then(response=>{ 
        //console.log("REOPNSE")
        //console.log(response)
        window.localStorage.setItem('accessToken', response.token) 
        toast.success(response.message,  {
            position: "top-center",
            autoClose: 5000,
            closeButton:false,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
        })
      }).catch(error=>{ 
        //console.log(error);
        toast.error(error.message, {
          position: "top-center",
          autoClose: 5000,
          closeButton:false,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
      });
      })
    }  
  }
componentWillUnmount(){
  //console.log("APP COMPONENT UNMOUNT")
}
  render(){
    return ( 
        <ThemeProvider>
           <IdleTimerProvider
      timeout={30 * 1000 * 60}
      onPrompt={this.onPrompt}
      onIdle={this.onIdle} 
      onActive={this.onActive}
      onAction={this.onAction}
    >
          <ScrollToTop /> 

      <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar
                  newestOnTop={false}
                  closeOnClick={false}
                  rtl={false}
                  pauseOnFocusLoss={false}
                  draggable={false}
                  pauseOnHover={false}
                  />
            <Router />
            </IdleTimerProvider>
        </ThemeProvider> 
    );
  }
}
